export enum EnumNavigateDirectionImage {
	LEFT,
	RIGHT,
}
